import { render, staticRenderFns } from "./AddReport.vue?vue&type=template&id=22de63cc&"
import script from "./AddReport.vue?vue&type=script&lang=js&"
export * from "./AddReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports